import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('../views/About.vue')
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import('../views/Contact.vue')
  },
  {
    path: '/news',
    name: 'news',
    component: () => import('../views/News.vue')
  },
  {
    path: '/careers',
    name: 'careers',
    component: () => import('../views/Careers.vue')
  },
  {
    path: '/agents',
    name: 'agents',
    component: () => import('../views/Agents.vue')
  },
  {
    path: '/products',
    name: 'products',
    component: () => import('../views/Products.vue')
  },
  {
    path: '/products/:id',
    name: 'product_details',
    component: () => import('../views/Products.vue')
  },
  {
    path: '/downloads',
    name: 'downloads',
    component: () => import('../views/Downloads.vue')
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('../views/Dashboard.vue')
  },
  {
    path: '/financials',
    name: 'financials',
    component: () => import('../views/Financials.vue')
  },
  {
    path: '/mobile_app',
    name: 'mobile_app',
    component: () => import('../views/MobileApp.vue')
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('../views/Register.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/Login.vue')
  },
  {
    path: '/forgot_password',
    name: 'forgot_password',
    component: () => import('../views/ForgotPassword.vue')
  },
  {
    path: '/salvages',
    name: 'salvages',
    component: () => import('../views/Salvages.vue')
  },
  {
    path: '/mypolicies',
    name: 'mypolicies',
    component: () => import('../views/MyPolicies.vue')
  },
  {
    path: '/myclaims',
    name: 'myclaims',
    component: () => import('../views/MyClaims.vue')
  },
  {
    path: '/promotions',
    name: 'promotions',
    component: () => import('../views/Promotions.vue')
  },
  {
    path: '/support',
    name: 'support',
    component: () => import('../views/Support.vue')
  },
  {
    path: '/terms',
    name: 'terms',
    component: () => import('../views/TermsOfUse.vue')
  },
  { 
    path: "*", 
    name: '404',
    component: () => import('../views/PageNotFound.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

 export default router
